module.exports = __webpack_public_path__ + "static/44-4522bbd0efaf172138980c22303484dd.png";